import React from 'react';
import PropTypes from 'prop-types';
import {onAdsContextInit} from '../../services/targeting';

export const Context = React.createContext(null);

export class MesoAdsContext extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            allowAds: false,
            isBrowser: typeof window !== 'undefined'
        };
        /* istanbul ignore next */
        if (this.state.isBrowser) {
            const isAdblock = (window.adblock || typeof window.adblock === 'undefined');
            this.state.allowAds = !isAdblock;
        }
    }

    componentDidMount() {
        /* istanbul ignore next */
        if (this.state.isBrowser) {
            const {brandId, locale, havId} = this.props;
            onAdsContextInit({brandId, locale, havId});
        }
    }

    render() {
        return (
            <Context.Provider value={this.state}>
                {this.props.children}
            </Context.Provider>
        );
    }
}

MesoAdsContext.propTypes = {
    brandId: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    havId: PropTypes.string.isRequired,
    gaiaId: PropTypes.string
};
